import lodash from 'lodash';

import type { RichContent } from './../../ricos-schema/legacy/wix/rich_content/v1';

type Nodes = RichContent['nodes'];
type isEqualType = (a: RichContent | undefined, b: RichContent | undefined) => boolean;

const normalizeNodesIds = (nodes: Nodes | undefined): Nodes | undefined => {
  let i = 0;
  if (!nodes) {
    return undefined;
  }

  const normalizeIds = (nodes: Nodes): Nodes => {
    if (nodes?.length === 0) {
      return [];
    }
    return nodes?.map(node => {
      const { id: _, nodes, ...rest } = node;
      return {
        ...rest,
        id: `${i++}`,
        ...(nodes && { nodes: normalizeIds(nodes) }),
      };
    });
  };
  return normalizeIds(nodes);
};

export const isRichContentEqual: isEqualType = (a = { nodes: [] }, b = { nodes: [] }) => {
  // remove undefined fields
  const aNormalized: RichContent = JSON.parse(JSON.stringify(a));
  const bNormalized: RichContent = JSON.parse(JSON.stringify(b));

  if (!lodash.isEqual(aNormalized.documentStyle, bNormalized.documentStyle)) {
    return false;
  }

  if (aNormalized.nodes?.length !== bNormalized.nodes?.length) {
    return false;
  }

  const aNodes = normalizeNodesIds(aNormalized.nodes);
  const bNodes = normalizeNodesIds(bNormalized.nodes);

  if (!lodash.isEqual(aNodes, bNodes)) {
    return false;
  }
  return true;
};
